/**
 * Підписи полів контакту CRM (`SPEC-008` §4.2) — тексти легасі
 * (`ClientContactResource.js:6-36`), «Ім'я» — з апострофом (D-23).
 *
 * «Пошта» — підпис клієнта; перевізник підписує те саме поле «E-mail»
 * (`SPEC-008` §4.2), тож власник може його перекрити.
 */
export const CRM_CONTACT_FIELD_LABELS = {
    name: "Ім'я",
    lastName: 'Прізвище',
    position: 'Посада',
    comment: 'Коментар',
    email: 'Пошта',
    phone: 'Телефон',
    fullNameEnglish: 'ПІБ (англомовний формат)',
    birthDay: 'Дата народження',
    createdAt: 'Дата створення',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const

/** Права рядка контакту: `update`/`delete` = `update` власника (`SPEC-009` §9.2). */
export interface CrmContactPermissions {
    read?: boolean
    update?: boolean
    delete?: boolean
    comment?: boolean
}

/** Контакт так, як його віддає колекція (`crm_contact:collection:read`). */
export interface CrmContactRow {
    uuid: string
    '@id'?: string
    /** «Прізвище Ім'я» — назва запису (`crm_contact:short:read`) */
    title?: string | null
    name?: string | null
    lastName?: string | null
    position?: string | null
    email?: string | null
    phone?: string | null
    _permissions?: CrmContactPermissions
    [key: string]: unknown
}

/** Колонка вкладки «Контакти»: поле запису й підпис. */
export interface CrmContactColumn {
    key: keyof CrmContactRow & string
    title: string
}

/** Колонки за замовчуванням — як у легасі (`ClientContactCrud.jsx:29`). */
export const CRM_CONTACT_DEFAULT_COLUMNS: CrmContactColumn[] = [
    { key: 'name', title: CRM_CONTACT_FIELD_LABELS.name },
    { key: 'lastName', title: CRM_CONTACT_FIELD_LABELS.lastName },
    { key: 'email', title: CRM_CONTACT_FIELD_LABELS.email },
]
